if (customElements.get('component-main-success-stories') === undefined) {
  class ComponentMainSuccessStories extends HTMLElement {
    constructor() {
      super();
      this.activeCategory = this.getAttribute('blog-url');
      this.successStoriesListId = 'success-stories-list';
      this.successStoriesList = document.getElementById(this.successStoriesListId);
    }

    connectedCallback() {
      this.initCategoryListener();
      this.initPaginationListener();
    }

    fetchSuccessStories(page) {
      return fetch(`${this.activeCategory}${page ? `?page=${page}` : ''}`)
        .then((response) => response.text())
        .then((data) => {
          const html = data;
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const storiesGrid = parsedHTML.getElementById(this.successStoriesListId);

          this.successStoriesList.innerHTML = '';
          this.successStoriesList.insertAdjacentHTML('beforeend', storiesGrid.innerHTML.trim());

          return storiesGrid;
        });
    }

    initCategoryListener() {
      const categoryLinks = this.querySelectorAll('[data-category-link]');
      categoryLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.activeCategory = event.currentTarget.dataset.categoryLink;
          link.classList.add('active');

          categoryLinks.forEach((otherLink) => {
            if (otherLink !== link) {
              otherLink.classList.remove('active');
            }
          });

          this.fetchSuccessStories();
        });
      });
    }

    initPaginationListener() {
      document.body.addEventListener('click', (event) => {
        const paginationComponent = this.querySelector('.pagination-wrapper');

        if (
          paginationComponent.contains(event.target) &&
          (event.target.hasAttribute('data-pagivation-link') ||
            event.target.parentElement.hasAttribute('data-pagivation-link'))
        ) {
          event.preventDefault();
          const page =
            parseInt(event.target.dataset.pagivationLink) ||
            parseInt(event.target.parentElement.dataset.pagivationLink);
          this.fetchSuccessStories(page);
        }
      });
    }
  }

  customElements.define('component-main-success-stories', ComponentMainSuccessStories);
}
